import React, { FunctionComponent } from 'react';

import styled from 'styled-components';

import Box from '@material-ui/core/Box';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';

const StyledTypography = styled(Typography)({
  textShadow: '1px 1px 3px rgba(0,0,0,0.1)',
});

type Quote = {
  subtitle: string;
  href?: string;
};

const Quote: FunctionComponent<Quote> = ({ children, subtitle, href }) => {
  return (
    <>
      <StyledTypography variant="h3" color="textSecondary">
        „{children}“
      </StyledTypography>

      <Box mt={2}>
        {href ? (
          <Link
            // href={href}
            color="textSecondary"
            variant="body2"
            underline="always"
          >
            {subtitle}
          </Link>
        ) : (
          <StyledTypography>{subtitle}</StyledTypography>
        )}
      </Box>
    </>
  );
};

export default Quote;
